import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import orderBy from 'lodash/orderBy';
import AssignCourseLegacy from '../../components/assign-course-legacy';
import classEnum from '../class-roll/constants';
import * as actionTypes from './action-types';

class AssignCoursesLegacy extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchQuery: '',
            filteredCourses: [],
            selectedYearGroupId: '-1',
            selectedCountryId: '-1',
            yearGroups: [],
            initialLoad: true
        };

        this.countries = [];
        this.selectedCourse = { id: -1, name: '' };
        this.selectedCountryId = '-1';
    }

    componentDidMount() {
        const { selectedProduct, dispatch } = this.props;
        dispatch({ type: actionTypes.GET_COUNTRY_REQUEST, selectedProductId: selectedProduct.id });
    }

    componentWillReceiveProps(nextProps) {
        const { yearGroups, countries, courses, deselectCourse } = nextProps;

        this.countries = countries;
        this.selectedCourse = nextProps.selectedCourse;

        if (this.props.courses !== courses) {
            if (this.selectedCountryId === classEnum.SCHOOL_COURSES) {
                this.updateCourseSelection(courses);
            } else {
                this.updateCourseSelection(orderBy(courses, ['isDefault'], ['desc']));
            }
        }

        if (deselectCourse) {
            this.clearSelectedCourse(yearGroups);
        } else {
            this.setState({ yearGroups });
        }
    }

    clearSelectedCourse = (yearGroups) => {
        const { dispatch } = this.props;
        const filteredCourses = this.state.filteredCourses.map(course => ({
            ...course,
            isSelected: false
        }));
        this.setState({ filteredCourses, yearGroups });
        dispatch({ type: actionTypes.DESELECT_COURSE, deselectCourse: false });
    }

    handleOnCountryChange = (name, value) => {
        const { dispatch } = this.props;
        this.selectedCountryId = value;

        this.setState({
            selectedCountryId: value,
            selectedYearGroupId: '-1',
            filteredCourses: [],
            searchQuery: ''
        });

        if (value !== '-1' && value !== classEnum.SCHOOL_COURSES) {
            dispatch(
                {
                    type: actionTypes.GET_COUNTRY_YEAR_GROUPS_REQUEST,
                    countryCode: value,
                    countryCourses: []
                }
            );
        }

        if (value === classEnum.SCHOOL_COURSES) {
            dispatch({ type: actionTypes.GET_YEAR_GROUP_REQUEST });
        }

        dispatch({ type: actionTypes.CLEAR_COURSE_LIST, productCourses: [] });
        this.selectedCourse = { id: -1, name: '' };
        this.props.handleOnCourseSelection(this.selectedCourse, true);
    }

    handleOnYearGroupChange = (name, value) => {
        const { selectedProduct, dispatch } = this.props;

        this.setState({ selectedYearGroupId: value, initialLoad: false, searchQuery: '' });

        if (this.selectedCountryId === classEnum.SCHOOL_COURSES) {
            if (value !== '-1') {
                dispatch({ type: actionTypes.GET_SCHOOL_COURSE_REQUEST, yearGroup: value });
            } else {
                this.updateCourseSelection();
            }
        } else if (value !== '-1') {
            dispatch({
                type: actionTypes.GET_FILTERED_LEGACY_COURSES_REQUEST,
                countryCode: this.selectedCountryId,
                productId: selectedProduct.id,
                yearGroup: value,
                isProductCoursesLoaded: false,
                isProductCoursesFetching: true,
                selectGenericCourses: false,
                includeGlobalCourses: true
            });
        } else {
            this.updateCourseSelection();
        }

        this.selectedCourse = { id: -1, name: '' };
        this.props.handleOnCourseSelection(this.selectedCourse, true);
    }

    handleOnClearSearch = () => {
        const { courses } = this.props;

        this.setState({ searchQuery: '' });

        if (this.selectedCountryId === classEnum.SCHOOL_COURSES) {
            this.updateCourseSelection(courses);
        } else {
            this.updateCourseSelection(orderBy(courses, ['isDefault'], ['desc']));
        }
    }

    assignToYearGroup = () => {
        this.props.assignToYearGroup(this.selectedCourse);
        this.clearSelectedCourse();
    }

    handleOnSearchCourse = (e) => {
        const { courses } = this.props;
        let courseFilter = [];
        if (this.selectedCountryId === classEnum.SCHOOL_COURSES) {
            courseFilter = courses;
        } else {
            courseFilter = orderBy(courses, ['isDefault'], ['desc']);
        }
        const filteredCourses = courseFilter.filter(course =>
            course.name.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1);

        if (!filteredCourses.length) {
            this.selectedCourse = { id: -1, name: '' };
            this.props.handleOnCourseSelection(this.selectedCourse, true);
        }

        this.setState({ searchQuery: e.target.value });
        this.updateCourseSelection(filteredCourses);
    }

    handleOnCourseSelection = (course) => {
        this.selectedCourse = course;
        this.updateCourseSelection(this.state.filteredCourses);
        this.props.handleOnCourseSelection(course);
    }

    updateCourseSelection = (courses = []) => {
        const filteredCourses = courses.map((course) => {
            let isSelected = false;
            if (this.selectedCourse && (course.name.toLowerCase() === this.selectedCourse.name.toLowerCase())) {
                isSelected = true;
            }
            return {
                ...course,
                isSelected
            };
        });
        this.setState({ filteredCourses });
    }

    disableYearGroup = () => this.selectedCountryId === '-1'

    disableSearchCourse = () => {
        const { selectedYearGroupId } = this.state;
        return this.selectedCountryId === '-1' || selectedYearGroupId === '-1';
    }

    handleOnViewCourse = (courseId) => {
        this.props.dispatch({ type: actionTypes.SHOW_COURSE_DETAILS, courseId });
    }

    render() {
        const {
            filteredCourses,
            initialLoad,
            searchQuery,
            selectedYearGroupId,
            yearGroups } = this.state;

        return (
            <AssignCourseLegacy
                countries={this.countries}
                disableSearch={this.disableSearchCourse()}
                disableYearGroup={this.disableYearGroup()}
                filteredCourses={filteredCourses}
                handleOnCountryChange={this.handleOnCountryChange}
                handleOnSearchCourse={this.handleOnSearchCourse}
                handleOnViewCourse={this.handleOnViewCourse}
                handleOnYearGroupChange={this.handleOnYearGroupChange}
                initialLoad={initialLoad}
                searchQuery={searchQuery}
                selectedYearGroupId={selectedYearGroupId}
                yearGroups={yearGroups}
                {...this.props}
                assignToYearGroup={this.assignToYearGroup}
                handleOnCourseSelection={this.handleOnCourseSelection} />
        );
    }
}

AssignCoursesLegacy.propTypes = {
    selectedProduct: PropTypes.object,
    countries: PropTypes.array,
    courses: PropTypes.array,
    yearGroups: PropTypes.array,
    handleOnCourseSelection: PropTypes.func.isRequired,
    selectedCourse: PropTypes.object,
    isProductCoursesLoaded: PropTypes.bool,
    isSchoolCoursesLoaded: PropTypes.bool,
    deselectCourse: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    assignToYearGroup: PropTypes.func.isRequired
};

function mapStateToProps(state = {}) {
    return {
        ...state,
        yearGroups: state.assignLegacyCourses.yearGroups,
        countries: state.assignLegacyCourses.countries,
        courses: state.assignLegacyCourses.productCourses,
        deselectCourse: state.assignLegacyCourses.deselectCourse,
        isLoadingCountryYearGroups: state.assignLegacyCourses.isLoadingCountryYearGroups,
        isProductCoursesLoaded: state.assignLegacyCourses.isProductCoursesLoaded,
        isSchoolCoursesLoaded: state.assignLegacyCourses.isSchoolCoursesLoaded,
        isCourseModalVisible: state.defaultCourses.isCourseModalVisible,
        courseDetails: state.defaultCourses.courseDetails,
        fetchingCourse: state.defaultCourses.fetchingCourse,
        selectedProduct: state.product,
        forYear: PropTypes.bool
    };
}

export default connect(mapStateToProps)(AssignCoursesLegacy);



// WEBPACK FOOTER //
// ./app/containers/assign-courses-legacy/index.js